import * as React from 'react';

const SvgUsingErgStoreIt = (props) => (
  <svg
    width="auto"
    height="auto"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 258 388"
    {...props}
  >
    <g clipPath="url(#clip0_1_1515)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.45264 384.144L20.7537 384.648C37.2678 344.398 51.7659 308.656 65.078 269.473C69.7328 255.71 72.9348 245.744 75.87 237.795C81.7997 222.668 86.662 215.638 100.152 206.057C115.866 194.934 133.833 186.926 148.983 175.239C154.913 170.642 151.503 164.027 146.344 168.773C142.014 172.728 137.215 176.135 132.054 178.917C122.329 184.553 112.338 188.646 99.9149 195.023C79.8726 205.316 70.7112 215.786 63.3584 242.481C48.4157 297.029 29.5 333.097 1.45264 384.144Z"
        fill="url(#paint0_linear_1_1515)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.9741 385.212L64.1888 385.775L76.7597 345.287C82.2446 327.283 83.312 313.787 66.2345 302.664C59.9982 298.903 53.3277 295.915 46.3701 293.766C44.0575 299.698 44.0576 299.312 41.6264 305.067C64.426 316.664 64.6038 326.245 56.0058 349.559L40.9741 385.212Z"
        fill="url(#paint1_linear_1_1515)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.4269 385.212L48.5641 385.39L62.5582 346.593C71.4527 321.974 67.5391 316.249 41.6264 304.8C40.144 308.33 40.648 307.173 39.0767 310.732C62.2913 317.762 64.5149 325.563 57.1621 345.584L42.4269 385.212Z"
        fill="url(#paint2_linear_1_1515)"
      />
      <path
        d="M1.45264 384.144C29.5 333.097 48.4157 297.029 63.3584 242.541C70.7112 215.846 79.8726 205.316 99.9149 195.083C112.338 188.706 122.329 184.612 132.054 178.977C139.23 175.063 145.72 170.004 151.266 163.998C153.223 161.862 155.031 160.231 156.662 160.142C160.516 159.904 163.777 165.629 161.969 172.748C160.385 177.99 157.427 182.712 153.4 186.422C145.366 194.43 134.9 198.108 126.332 205.316C118.475 211.93 124.286 216.914 134.663 211.841C147.352 205.909 156.425 201.964 163.926 198.761C197.31 184.761 207.776 170.464 228.529 155.07C234.103 150.976 244.154 149.938 245.459 158.748C255.094 156.731 260.283 162.93 253.049 170.049L245.696 177.167C251.27 177.345 253.79 183.1 248.246 189.18L233.836 201.045C241.219 201.371 243.502 204.456 242.731 208.964C242.168 212.405 236.03 216.736 233.332 218.782L184.768 255.266C174.214 261.198 163.659 267.13 153.104 273.062C108.216 298.334 109.936 303.999 98.7289 353.801L91.554 386.517"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M246.022 158.54C236.298 161.506 222.659 175.566 213.824 182.744C204.558 190.133 194.634 196.657 184.176 202.231"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M245.726 177.108C238.136 177.938 233.481 182.002 227.937 186.6C221.236 192.146 209.051 201.638 202.587 206.235C197.067 210.174 191.248 213.674 185.184 216.706"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M236.208 200.926C231.264 201.57 226.595 203.572 222.719 206.71C201.965 223.231 202.291 223.824 177.268 236.668"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M123.693 208.015C117.081 217.507 117.763 229.549 112.249 239.931C109.596 244.882 105.611 248.992 100.745 251.795"
        stroke="white"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M118.149 27.9707H174.57V223.231L118.149 244.439V27.9707Z"
        fill="url(#paint3_linear_1_1515)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.1506 242.63C70.3852 256.037 70.652 263.393 77.5008 280.834C71.9565 277.245 68.6063 270.512 61.9058 269.384L65.0782 252.21L74.1506 242.63Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.203 293.588C120.313 284.423 123.485 281.724 131.253 276.592L145.069 267.694C153.43 262.295 160.131 259.418 168.136 267.456C172.553 271.935 169.944 274.635 166.179 276.948C154.735 283.889 143.528 290.83 132.232 298.037C128.377 300.885 122.062 302.931 121.203 293.588Z"
        fill="white"
        stroke="white"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.351 294.893L124.879 300.143H116.103L121.351 294.893Z"
        fill="white"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.982 223.736C97.5432 232.397 91.0799 240.672 82.9859 241.888C70.8004 243.846 69.0808 222.905 81.7703 210.477C95.8236 196.744 110.203 200.511 100.982 223.736Z"
        fill="#FF5E18"
      />
      <path
        d="M146.345 3.67822C146.034 3.68655 145.729 3.76784 145.455 3.91552L127.073 11.5385C126.557 11.7509 126.142 12.1548 125.917 12.6656L118.238 31.2633C118.059 31.7924 118.059 32.3655 118.238 32.8947L125.917 51.2847C126.011 51.5622 126.162 51.8167 126.362 52.0314C126.561 52.2461 126.803 52.4162 127.073 52.5305L145.455 60.1238C145.728 60.2676 146.037 60.3294 146.345 60.3017C146.633 60.3323 146.924 60.2699 147.175 60.1238L165.586 52.5305C166.14 52.292 166.577 51.8442 166.802 51.2847L174.392 32.8947C174.524 32.6432 174.594 32.3632 174.594 32.0789C174.594 31.7947 174.524 31.5148 174.392 31.2633L166.802 12.7546C166.545 12.2449 166.114 11.8447 165.586 11.6274L147.175 4.0045C146.932 3.82333 146.645 3.71065 146.345 3.67822ZM146.345 8.83931L162.71 15.6317L169.411 31.9751L162.71 48.3482L146.345 55.0517L130.008 48.3482L123.219 31.9751L130.008 15.6317L146.345 8.83931Z"
        fill="#FF5E18"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M169.441 32.0641L162.71 15.691L146.374 8.92822L130.008 15.691L123.219 32.0641L130.008 48.4371L146.374 55.1406L162.71 48.4371L169.441 32.0641Z"
        fill="#121212"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M144.565 35.5048H155.446V40.6659H137.212V35.9794L144.417 28.0598L137.212 20.5259V15.958H155.446V21.0301H144.802L151.444 27.9709L144.565 35.5048Z"
        fill="white"
      />
      <path
        d="M146.344 0C146.041 0.0163927 145.741 0.0763659 145.455 0.178006L127.073 7.86028C126.805 7.95275 126.562 8.10495 126.362 8.30537C126.161 8.50578 126.009 8.74915 125.917 9.01707L118.238 27.4071C118.068 27.968 118.068 28.5666 118.238 29.1275L125.917 47.5471C126.013 47.8201 126.165 48.0696 126.365 48.2792C126.564 48.4889 126.805 48.6538 127.073 48.7633L145.455 56.3565C145.741 56.4582 146.041 56.5182 146.344 56.5346C146.629 56.521 146.909 56.4608 147.175 56.3565L165.586 48.7633C165.859 48.6514 166.107 48.4863 166.316 48.2775C166.525 48.0687 166.69 47.8204 166.802 47.5471L174.392 29.1275C174.523 28.8596 174.591 28.5654 174.591 28.2673C174.591 27.9691 174.523 27.6749 174.392 27.4071L166.802 9.01707C166.692 8.74925 166.527 8.50766 166.318 8.30826C166.108 8.10886 165.859 7.95619 165.586 7.86028L147.175 0.178006C146.909 0.0737367 146.629 0.0135803 146.344 0ZM146.344 5.16109L162.71 11.9535L169.411 28.2969L162.71 44.581L146.344 51.3735L130.008 44.581L123.219 28.2969L130.008 11.9535L146.344 5.16109Z"
        fill="white"
      />
      <path
        d="M146.344 94.1748C146.042 94.1786 145.742 94.2286 145.455 94.3231L127.073 102.005C126.807 102.102 126.566 102.255 126.366 102.455C126.166 102.655 126.013 102.896 125.917 103.162L118.238 121.552C118.068 122.113 118.068 122.712 118.238 123.273L125.917 141.692C126.013 141.965 126.165 142.215 126.365 142.424C126.564 142.634 126.805 142.799 127.073 142.908L145.455 150.531C145.746 150.609 146.044 150.659 146.344 150.68C146.626 150.662 146.904 150.612 147.175 150.531L165.586 142.908C165.859 142.797 166.107 142.631 166.316 142.423C166.525 142.214 166.69 141.966 166.802 141.692L174.392 123.273C174.523 123.005 174.591 122.711 174.591 122.412C174.591 122.114 174.523 121.82 174.392 121.552L166.802 103.162C166.688 102.897 166.521 102.658 166.312 102.459C166.103 102.261 165.856 102.106 165.586 102.005L147.175 94.3231C146.908 94.2285 146.627 94.1783 146.344 94.1748ZM146.344 99.3062L162.71 106.099L169.411 122.472L162.71 138.756L146.344 145.519L130.008 138.756L123.219 122.472L130.008 106.099L146.344 99.3062Z"
        fill="#FF5E18"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M169.441 122.442L162.71 106.099L146.374 99.3062L130.008 106.099L123.219 122.442L130.008 138.726L146.374 145.519L162.71 138.726L169.441 122.442Z"
        fill="#121212"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M144.565 125.883H155.446V130.955H137.212V126.387L144.417 118.378L137.212 110.933V106.336H155.446V111.408H144.802L151.444 118.378L144.565 125.883Z"
        fill="white"
      />
      <path
        d="M146.344 90.4077C146.05 90.3629 145.75 90.3629 145.455 90.4077L127.073 98.0306C126.805 98.14 126.564 98.305 126.364 98.5146C126.165 98.7242 126.012 98.9738 125.917 99.2467L118.238 117.666C118.059 118.216 118.059 118.808 118.238 119.357L125.917 137.777C126.012 138.05 126.165 138.299 126.364 138.509C126.564 138.719 126.805 138.883 127.073 138.993L145.455 146.616C145.75 146.661 146.05 146.661 146.344 146.616C146.619 146.661 146.9 146.661 147.174 146.616L165.586 138.993C165.859 138.881 166.107 138.716 166.316 138.507C166.525 138.298 166.69 138.05 166.802 137.777L174.392 119.357C174.522 119.094 174.59 118.805 174.59 118.512C174.59 118.218 174.522 117.929 174.392 117.666L166.802 99.2467C166.69 98.9734 166.525 98.7252 166.316 98.5164C166.107 98.3076 165.859 98.1424 165.586 98.0306L147.174 90.4077C146.9 90.3628 146.619 90.3628 146.344 90.4077ZM146.344 95.5391L162.71 102.331L169.411 118.616L162.71 134.989L146.344 141.781L130.008 134.989L123.219 118.616L130.008 102.331L146.344 95.5391Z"
        fill="white"
      />
      <path
        d="M146.345 198.79C146.04 198.766 145.735 198.817 145.455 198.939L127.073 206.561C126.557 206.774 126.142 207.178 125.917 207.689L118.238 226.138C118.059 226.667 118.059 227.24 118.238 227.769L124.168 242.333L128.733 240.524L123.1 226.939L129.89 210.595L146.226 203.803L162.592 210.595L168.522 225.159L173.117 223.35L166.654 207.629C166.397 207.12 165.966 206.719 165.438 206.502L147.026 198.879C146.808 198.8 146.576 198.77 146.345 198.79Z"
        fill="#FF5E18"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M168.744 224.69L162.755 210.156L146.419 203.364L130.053 210.156L123.263 226.5L128.926 240.085L168.744 224.69Z"
        fill="#121212"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M144.565 230.439H155.12L141.956 235.6H137.212V230.943L144.417 222.994L137.212 215.46V210.892H155.446V215.964H144.802L151.444 222.905L144.565 230.439Z"
        fill="white"
      />
      <path
        d="M146.344 194.934C146.041 194.95 145.741 195.01 145.455 195.112L127.073 202.794C126.805 202.887 126.562 203.039 126.362 203.239C126.161 203.44 126.009 203.683 125.917 203.951L118.238 222.341C118.068 222.902 118.068 223.501 118.238 224.062L125.679 241.858L130.749 239.812L130.008 239.574L123.219 223.201L130.008 206.858L146.344 200.066L162.71 206.858L169.411 223.201L168.61 225.248L174.54 222.875C174.509 222.679 174.449 222.489 174.362 222.312L166.772 203.921C166.663 203.654 166.498 203.412 166.288 203.213C166.079 203.013 165.829 202.861 165.557 202.765L147.145 195.082C146.887 194.991 146.617 194.941 146.344 194.934Z"
        fill="white"
      />
      <path
        d="M177.987 223L117 246.551"
        stroke="#FF5E18"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1_1515"
        x1="51.4995"
        y1="267.5"
        x2="23.5438"
        y2="368.512"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#25211A" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_1515"
        x1="-43.3013"
        y1="386.113"
        x2="-26.4431"
        y2="421.518"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5E18" />
        <stop offset="1" stopColor="#121212" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1_1515"
        x1="56.3319"
        y1="320.343"
        x2="56.3319"
        y2="385.598"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#121212" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1_1515"
        x1="94.875"
        y1="223.943"
        x2="96.3588"
        y2="54.873"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5E18" stopOpacity="0" />
        <stop offset="1" stopColor="#FF5E18" />
      </linearGradient>
      <clipPath id="clip0_1_1515">
        <rect width="258" height="388" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgUsingErgStoreIt;
